<template>
  <div
    class="flex align-center justify-end m-2"
  >
    <div
      v-for="(color, idx) in palette.colors"
      class="w-16 h-16 shadow"
      v-bind:key="idx"
      v-bind:style="{ background: `hsl(${color.h}, ${color.s}%, ${color.l}%)`}"
      @click="copy(color)"
    >
      <div
        class="h-16 w-full flex items-center justify-center text-white hover-transparent-white"
      >
        <font-awesome-icon icon="copy" class="svg-shadow" />
      </div>
    </div>
    <div
      class="w-16 h-16 flex items-center justify-center"
      v-on:click="removePalette"
    >
      <font-awesome-icon icon="trash-alt" class="svg-shadow" />
    </div>
    <div
      class="w-16 h-16 flex items-center justify-center"
    >
      <font-awesome-icon icon="crosshairs" class="svg-shadow" />
    </div>
  </div>
</template>

<script>
import Clipboard from '../mixins/clipboard';

export default Clipboard.extend({
  name: 'SavedPalette',
  props: [
    'palette',
  ],
  methods: {
    copy(color) {
      return this.copyValue(color);
    },
    removePalette() {
      this.$emit('removePalette', this.$vnode.key);
    },
  },
});
</script>
